"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var Div_1 = __importDefault(require("../Div"));
var integersStyle = {
    fontSize: '200px',
    display: 'inline-block'
};
var decimalsStyle = {
    fontSize: '88px',
    display: 'inline-block',
    position: 'relative',
    top: '-0.8em'
};
var generatePriceStyles = function (styles, itemsCount) {
    var commonStyles = {
        whiteSpace: 'nowrap',
        position: 'absolute',
        bottom: '5%',
        right: '0%'
    };
    if (itemsCount === 1) {
        return __assign(__assign(__assign({}, styles), { transformOrigin: 'right', float: 'right', transform: 'scale(1.6)' }), commonStyles);
    }
    else if (itemsCount === 2) {
        return __assign(__assign(__assign({}, styles), { float: 'right', transformOrigin: 'right', transform: 'scale(1.4)' }), commonStyles);
    }
    else if (itemsCount < 5) {
        return __assign(__assign({}, styles), { transformOrigin: 'right', float: 'right', transform: 'scale(1.1)', whiteSpace: 'nowrap', position: 'absolute', bottom: '-5%', right: '-5%' });
    }
    else if (itemsCount < 7) {
        return __assign(__assign({}, styles), { transformOrigin: 'right', float: 'right', transform: 'scale(0.9)', whiteSpace: 'nowrap', position: 'absolute', bottom: '-5%', right: '-3%' });
    }
    else if (itemsCount < 9) {
        return __assign(__assign({}, styles), { transformOrigin: 'right', float: 'right', transform: 'scale(0.8)', whiteSpace: 'nowrap', position: 'absolute', bottom: '-5%', right: '-3%' });
    }
    return __assign(__assign({}, styles), { transformOrigin: 'right', float: 'right', transform: 'scale(0.8)', whiteSpace: 'nowrap', position: 'absolute', bottom: '0%', right: '0%' });
};
var Price = function (_a) {
    var styles = _a.styles, priceUnitStyles = _a.priceUnitStyles, priceIntegers = _a.priceIntegers, priceDecimals = _a.priceDecimals, unit = _a.unit, itemsCount = _a.itemsCount;
    return (react_1.default.createElement(Div_1.default, { styles: generatePriceStyles(styles, itemsCount) },
        react_1.default.createElement("div", { style: integersStyle }, priceIntegers),
        react_1.default.createElement("div", { style: decimalsStyle }, priceDecimals),
        react_1.default.createElement("div", { style: unit ? priceUnitStyles : { visibility: 'hidden' } }, unit ? unit : 'kpl' // visibility: 'hidden' is temporary for price element align
        )));
};
exports.default = Price;
//# sourceMappingURL=Price.js.map